import { render } from "./OrderDetailView.vue?vue&type=template&id=9f8dba10&scoped=true&ts=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=ts"
export * from "./OrderDetailView.vue?vue&type=script&lang=ts"

import "./OrderDetailView.vue?vue&type=style&index=0&id=9f8dba10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1501305b0fb1954c01d0b4f35a9e823f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8dba10"]])

export default __exports__